export default __webpack_public_path__ + "static/media/grafema_design-factory-kitchen-pictograms_04.b93bbeb3.gif";